import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  emuUrl = "";
  hasLoaded = false;

  initialize() {
    this.unloadPlayElements();
    this.element.addEventListener("click", this.loadPlayElements.bind(this));

    const backButtonElement = document.querySelector("#game-back-button");
    const backUrl = backButtonElement.dataset.backUrl;
    backButtonElement.addEventListener("click", this.back.bind(this, backUrl));
  }

  checkRomExpiration() {
    const romUrl = document.querySelector("#rom_url").value;
    const urlObj = new URL(romUrl, window.location.origin);
    const expires = urlObj.searchParams.get("Expires");
    const expiresTimestamp = parseInt(expires);
    const currentTimestamp = Math.floor(Date.now() / 1000);
    return expiresTimestamp < currentTimestamp;
  }

  async reloadRom() {
    const currentUrl = window.location.href;
    const response = await fetch(currentUrl, {
      method: "GET",
      headers: {
        "Accept": "text/html",
        "Content-Type": "text/html",
        "User-Agent": navigator.userAgent,
      }
    });
    const htmlText = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    const newRomURL = doc.querySelector("#rom_url").value;
    const romURLElement = document.querySelector("#rom_url");
    romURLElement.value = newRomURL;
  }

  unloadPlayElements() {
    const gameLoaderContainer = document.querySelector("#game-loader");
    const emuURLElement = gameLoaderContainer.querySelector("#emu_url");
    this.emuUrl = emuURLElement.value;
    emuURLElement.remove();
  }

  loadPlayElements() {
    if (this.hasLoaded == true) return;
    this.hasLoaded = true;

    const gameMainContainer = document.querySelector(".play-main");
    gameMainContainer.style.opacity = 1;

    this.loadEmulator();
  }

  async loadEmulator() {
    if (this.checkRomExpiration()) await this.reloadRom();

    const gameLoaderContainer = document.querySelector("#game-loader");
    const emuScriptElement = document.createElement("script");
    emuScriptElement.src = this.emuUrl;

    gameLoaderContainer.appendChild(emuScriptElement);
  }

  back(backUrl) {
    if (history.length > 1) {
      history.back();
    } else {
      window.location.href = backUrl;
    }
  }
}
